export default __webpack_public_path__ + "static/media/Ytoth.a3f5412d.jpg";